export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/green-checkmark-circle.469f5ea4.svg","height":24,"width":25};